import { useEffect, useState } from "react";
import { Star } from "lucide-react";
import { api } from "../lib/api";
import TestimonialCard from "../components/TestimonialCard";
import CTASection from "../components/CTASection";

export default function Opiniones() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("Todos");

  useEffect(() => {
    api.get("/testimonials").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const services = ["Todos", ...new Set(items.map((t) => t.service).filter(Boolean))];
  const filtered = filter === "Todos" ? items : items.filter((t) => t.service === filter);

  return (
    <div data-testid="opiniones-page">
      <section className="py-20 bg-gradient-to-b from-teal-50/60 to-white">
        <div className="container-max">
          <div className="max-w-3xl">
            <div className="inline-flex items-center gap-3 bg-white border border-slate-200 rounded-full px-4 py-2 mb-6 shadow-sm">
              <div className="flex gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <Star key={i} className="w-3.5 h-3.5 fill-amber-400 text-amber-400" />
                ))}
              </div>
              <span className="text-xs font-semibold text-slate-700">4.9/5 · +500 opiniones</span>
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
              Opiniones <span className="underline-accent">reales</span> de nuestros pacientes
            </h1>
            <p className="text-lg text-slate-600 leading-relaxed">
              Nuestra mejor carta de presentación son las historias de quienes ya han confiado en nosotros.
            </p>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="container-max">
          <div className="flex flex-wrap gap-2 mb-10" data-testid="testimonial-filters">
            {services.map((s) => (
              <button
                key={s}
                onClick={() => setFilter(s)}
                data-testid={`filter-${s}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  filter === s
                    ? "bg-orange-600 text-white"
                    : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                }`}
              >
                {s}
              </button>
            ))}
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((t) => (
              <TestimonialCard key={t.id} t={t} />
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
